import apiClient from '@/services/axios'
import config from '@/configs'

// * recipients functions
// get all recipients
export async function fetchRecipientGroups() {
  return apiClient
    .get(config.api.marketing.recipients)
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[Marketing/Recipients API]:', err))
}

// get a recipient group by id
export async function fetchRecipientGroup(id) {
  return apiClient
    .get(`${config.api.marketing.recipients}/${id}`)
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[Marketing/Recipients API]:', err))
}

// get recipients ids by filter
export async function fetchRecipientsIdsByFilter(filter) {
  return apiClient
    .post(config.api.marketing.recipientsByFilter, filter)
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[Marketing/Recipients API]:', err))
}

// create a new recipient
export async function createRecipientGroup(recipient_group) {
  return apiClient
    .post(config.api.marketing.recipients, recipient_group)
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[Marketing/Recipients API]:', err))
}

// update a recipient
export async function updateRecipientGroup(recipient_group) {
  return apiClient
    .put(config.api.marketing.recipients, recipient_group)
    .then((res) => (res && res.data ? res.data : null))
    .catch((err) => console.error('[Marketing/Recipients API]:', err))
}
